import(/* webpackMode: "eager" */ "/app/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/[lang]/providers.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/footer/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/header/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/modules/dynamic-viewport/index.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[lang]/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PrimeReactProvider"] */ "/app/node_modules/primereact/api/api.esm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primereact/resources/themes/lara-light-cyan/theme.css");
